import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import BlogGuidePage from "@/pages/blog/vigorbuy-spreadsheet-ultimate-guide/page";
import SafetyGuidePage from "@/pages/blog/vigorbuy-spreadsheet-safety-guide/page";
import CategoryDeepDivePage from "@/pages/blog/vigorbuy-spreadsheet-category-deep-dive/page";
import BeginnersFirstStepsPage from "@/pages/blog/vigorbuy-spreadsheet-beginners-first-steps/page";
import QCPhotosGuidePage from "@/pages/blog/vigorbuy-spreadsheet-qc-photos-guide/page";
import BestShoesPage from "@/pages/blog/vigorbuy-spreadsheet-best-shoes-2026/page";
import VsShoppingPage from "@/pages/blog/vigorbuy-spreadsheet-vs-traditional-shopping/page";
import TopAccessoriesPage from "@/pages/blog/vigorbuy-spreadsheet-top-accessories/page";
import SeasonalTrendsPage from "@/pages/blog/vigorbuy-spreadsheet-seasonal-trends/page";
import SpotQualityPage from "@/pages/blog/vigorbuy-spreadsheet-spot-quality/page";
import InternationalBuyerPage from "@/pages/blog/vigorbuy-spreadsheet-international-buyer-guide/page";
import HiddenGemsPage from "@/pages/blog/vigorbuy-spreadsheet-hidden-gems/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/blog/vigorbuy-spreadsheet-ultimate-guide",
    element: <BlogGuidePage />,
  },
  {
    path: "/blog/vigorbuy-spreadsheet-safety-guide",
    element: <SafetyGuidePage />,
  },
  {
    path: "/blog/vigorbuy-spreadsheet-category-deep-dive",
    element: <CategoryDeepDivePage />,
  },
  {
    path: "/blog/vigorbuy-spreadsheet-beginners-first-steps",
    element: <BeginnersFirstStepsPage />,
  },
  {
    path: "/blog/vigorbuy-spreadsheet-qc-photos-guide",
    element: <QCPhotosGuidePage />,
  },
  {
    path: "/blog/vigorbuy-spreadsheet-best-shoes-2026",
    element: <BestShoesPage />,
  },
  {
    path: "/blog/vigorbuy-spreadsheet-vs-traditional-shopping",
    element: <VsShoppingPage />,
  },
  {
    path: "/blog/vigorbuy-spreadsheet-top-accessories",
    element: <TopAccessoriesPage />,
  },
  {
    path: "/blog/vigorbuy-spreadsheet-seasonal-trends",
    element: <SeasonalTrendsPage />,
  },
  {
    path: "/blog/vigorbuy-spreadsheet-spot-quality",
    element: <SpotQualityPage />,
  },
  {
    path: "/blog/vigorbuy-spreadsheet-international-buyer-guide",
    element: <InternationalBuyerPage />,
  },
  {
    path: "/blog/vigorbuy-spreadsheet-hidden-gems",
    element: <HiddenGemsPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;